<template>
    <div class="text-lg" :data-cy="transaction.transactionName">
        <transaction-link
            :transaction-uuid="transaction.uuid"
            :class="{ 'text-error': transaction.deleted, 'text-primary': !transaction.deleted }"
        >
            {{ transaction.transactionName }}
        </transaction-link>
    </div>
</template>

<script setup lang="ts">

import {computed, provide} from 'vue'
import TransactionLink from '@/transaction/TransactionLink.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: any,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transaction = computed(() => {
    return props.params?.data
})

</script>

<style scoped>

</style>